import { shippingCountryLabel } from "@gaole/shared";
import { Input } from "./ui";
import { StateSelect } from "./StateSelect";

type AddressRegionFieldProps = {
  country: string;
  state: string;
  onStateChange: (value: string) => void;
};

export function AddressRegionField({ country, state, onStateChange }: AddressRegionFieldProps) {
  if (country === "MY") {
    return <StateSelect label="State" required value={state} onChange={onStateChange} />;
  }

  return (
    <Input
      label="State / region"
      required
      placeholder={country ? `Region in ${shippingCountryLabel(country)}` : "State or region"}
      value={state}
      onChange={(e) => onStateChange(e.target.value)}
    />
  );
}

export function formatAddressLocation(addr: {
  city: string;
  state: string;
  postcode: string;
  country?: string;
}): string {
  const countryLabel = addr.country && addr.country !== "MY" ? shippingCountryLabel(addr.country) : null;
  const locality = [addr.postcode, addr.city, addr.state].filter(Boolean).join(" ");
  return countryLabel ? `${locality}, ${countryLabel}` : locality;
}
